import { Sparkles } from "lucide-react";

export default function Stats() {
  return (
    <section
      className="py-16 md:py-24 bg-brand-pine text-white relative overflow-hidden"
      data-testid="stats-section"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #C86A53 0, transparent 40%), radial-gradient(circle at 80% 60%, #C86A53 0, transparent 45%)",
        }}
      />
      <div className="container-site relative text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-4 py-2 mb-6">
          <Sparkles size={14} className="text-brand-clay" strokeWidth={2} />
          <span className="text-xs tracking-[0.22em] uppercase font-semibold text-white/80">
            A legacy of care
          </span>
        </div>

        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-[3.6rem] leading-tight max-w-4xl mx-auto">
          <span className="text-brand-clay">15+ years</span> of experience in
          dentistry — combined with{" "}
          <span className="italic font-light">various innovative ideas</span>
          {" "}that bring the clinic home.
        </h2>
      </div>
    </section>
  );
}
